import { render, staticRenderFns } from "./ProgressStateTag.vue?vue&type=template&id=1c87a86c&lang=pug"
import script from "./ProgressStateTag.vue?vue&type=script&lang=js"
export * from "./ProgressStateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports